export default __webpack_public_path__ + "static/media/facebook.8e3183da.svg";